import React, { Component } from 'react';
import { Container } from 'flux/utils';
import PropTypes from 'prop-types';

import Dialog from 'material-ui/Dialog';
import TextField from 'material-ui/TextField';
import FlatButton from 'material-ui/FlatButton';
import MenuItem from 'material-ui/MenuItem';
import SelectField from 'material-ui/SelectField';

import CertificateActions from '../../actions/CertificateActionCreator';
import DialogActions from '../../actions/DialogActionCreator';
import DialogStore from '../../stores/DialogStore';
import DataStore from '../../stores/DataStore';
import { DataTypes } from '../../constants/CentricConstants';

const style = {
    numberInput: {
        width:  '20%',
        marginRight:   '5%'
    },
    fontSelect: {
        width:  '55%',
        marginRight:   '5%'
    }
};

const nameField = /^\w+$/;
const colourTriplet = /^#?([0-9a-f]{3}){1,2}$/i;
const validate = draft => {
    let errors = {};
    if (!draft.name || draft.name.trim() === '') {
        errors.name = "This field is required";
    } else if (!nameField.test(draft.name)) {
        errors.name = "Invalid characters";
    }
    if (!draft.fontSize) {
        errors.fontSize = "This field is required";
    } else if (!Number(draft.fontSize)) {
        errors.fontSize = "Must be a number!";
    }
    ['baseX', 'baseY'].forEach(field => {
        if (draft[field].length === 0) {
            errors[field] = "This field is required";
        } else if (isNaN(Number(draft[field]))) {
            errors[field] = "Must be a number!";
        }
    });
    ['width', 'height'].forEach(field => {
        if (isNaN(Number(draft[field]))) {
            errors[field] = "Must be a number!";
        }
    });

    if (!draft.colour) {
        errors.colour = "This field is required";
    } else if (! colourTriplet.test(draft.colour)) {
        errors.colour = "Must be a hexadecimal colour value";
    }
    if (!draft.font) {
        errors.font = "This field is required";
    }

    return errors;
};

const onSelect = (field) => ({target}, index, value) => DialogActions.updateDraft(field, value);
const onTextChange = ({target}) => (!!target.name) && DialogActions.updateDraft(target.name, target.value);


class CertificateFieldDialog extends Component {

    componentDidMount() {
        this.onSave = this.onSave.bind(this);
        this.onRemove = this.onRemove.bind(this);
        CertificateActions.getFonts();
    }
    
    render() {
        return (
            <Dialog
                title="Placeholder"
                open={true}
                modal={true}
                onRequestClose={this.props.onClose}
                actions={[
                    this.props.onRemove && <FlatButton key="remove" label="Remove" secondary={true} onTouchTap={this.onRemove}/>,
                    <FlatButton key="cancel" label="Cancel" onTouchTap={this.props.onCancel}/>,
                    <FlatButton key="submit" label="Submit" primary={true} onTouchTap={this.onSave} disabled={!this.state.isValid}/>
                ]}
            >
                <TextField
                    name="name"
                    value={this.state.draft.name}
                    floatingLabelText="Field name"
                    onChange={onTextChange}
                    fullWidth={true}
                    errorText={this.state.errors.name}
                />
                <TextField
                    name="baseX"
                    value={this.state.draft.baseX}
                    floatingLabelText="Start X"
                    onChange={onTextChange}
                    errorText={this.state.errors.baseX}
                    style={style.numberInput}
                />
                <TextField
                    name="baseY"
                    value={this.state.draft.baseY}
                    floatingLabelText="Start Y"
                    onChange={onTextChange}
                    errorText={this.state.errors.baseY}
                    style={style.numberInput}
                />
                <TextField
                    name="width"
                    value={this.state.draft.width || ''}
                    floatingLabelText="Width"
                    onChange={onTextChange}
                    errorText={this.state.errors.width}
                    style={style.numberInput}
                />
                <TextField
                    name="height"
                    value={this.state.draft.height || ''}
                    floatingLabelText="Height"
                    onChange={onTextChange}
                    errorText={this.state.errors.height}
                    style={style.numberInput}
                />
                <SelectField
                    name="font"
                    value={this.state.draft.font}
                    floatingLabelText="Font family"
                    onChange={onSelect('font')}
                    errorText={this.state.errors.font}
                    fullWidth={true}
                >
                    {this.state.fonts.map(({id, name}) => <MenuItem key={id} value={id} primaryText={name} />)}
                </SelectField>
                <TextField
                    name="fontSize"
                    value={this.state.draft.fontSize}
                    floatingLabelText="Font Size"
                    onChange={onTextChange}
                    errorText={this.state.errors.fontSize}
                    style={style.numberInput}
                />
                <TextField
                    name="colour"
                    value={this.state.draft.colour}
                    floatingLabelText="Font Colour"
                    onChange={onTextChange}
                    errorText={this.state.errors.colour}
                    style={style.numberInput}
                />
                <SelectField
                    name="textAlign"
                    value={this.state.draft.textAlign}
                    floatingLabelText="Text Align"
                    onChange={onSelect('textAlign')}
                    fullWidth
                >
                    <MenuItem key="left" value="left" primaryText="Left" />
                    <MenuItem key="center" value="center" primaryText="Centre" />
                    <MenuItem key="right" value="right" primaryText="Right" />
                </SelectField>

            </Dialog>
        );
    }


    onSave() {
        const saved = this.props.onSave(this.state.draft);
        if (saved !== false && !!this.props.closeOnSave) { this.props.onClose(); }
    }

    onRemove() {
        const removed = this.props.onRemove(this.state.draft);
        if (removed !== false) { this.props.onClose(); }
    }
}

CertificateFieldDialog.getStores = () => ([DialogStore, DataStore]);
CertificateFieldDialog.calculateState = (prevState) => {
    const draft = DialogStore.getDraft();
    const errors = validate(draft);
    const isValid = Object.keys(errors).length === 0;
    return {
        draft,
        isValid,
        errors,
        fonts: DataStore.get(DataTypes.FONT_LIST) || []
    };
};
CertificateFieldDialog.propTypes = {
    onClose:        PropTypes.func,
    onCancel:       PropTypes.func,
    onRemove:       PropTypes.func,
    onSave:         PropTypes.func,
    closeOnSave:    PropTypes.bool
};

CertificateFieldDialog.defaultProps = {
    onClose:        DialogActions.close,
    onCancel:       DialogActions.close,
    onRemove:       null,
    onSave:         () => true,
    closeOnSave:    true
};

export default Container.create(CertificateFieldDialog);
